const MENU_OPENED = 'menu-opened';
import { SchedulerInstance } from '../AppointmentScheduler/AppointmentScheduler';

export default class HeaderMobile {
    constructor() {
        this.headerContainer = document.getElementById('main-header-mobile');
        this.menuLink = document.getElementById('menu-switcher-mobile');

        this.isOpened = false;

        this.menuOnClick = this.menuOnClick.bind(this);
        this.show = this.show.bind(this);
        this.hide = this.hide.bind(this);
    }

    init() {
        this.menuLink.onclick = this.menuOnClick;

        this.bindClosingTriggers();
    }

    get CLOSE_CLASS() {
        return 'js-header-close';
    }

    bindClosingTriggers() {
        [...document.getElementsByClassName(this.CLOSE_CLASS)]
            .map((elem) => {
                elem.addEventListener('click', () => {
                    this.hide();
                })
            });
    }

    menuOnClick(e) {
        e.preventDefault();
        this.toggleMenu();
    }

    toggleMenu() {
        this.isOpened ? this.hide() : this.show();
    }

    show() {
        document.body.classList.add(MENU_OPENED);
        this.isOpened = true;
    }

    hide() {
        document.body.classList.remove(MENU_OPENED);
        this.isOpened = false;
    }
}


// WEBPACK FOOTER //
// ./Src/Shared/Header/HeaderMobile.js